import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

export interface Badge {
  id: number;
  name: string;
  image: string;
  description: string;
  order: number;
  active: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class BadgeService {
  private url = 'badge';

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<Badge[]>(`${environment.apiUrl}/${this.url}`);
  }

  get(id: number) {
    return this.http.get<Badge>(`${environment.apiUrl}/${this.url}/${id}`);
  }

  add(badge: Partial<Badge>) {
    return this.http.post(`${environment.apiUrl}/${this.url}`, badge);
  }

  update(id: number, badge: Partial<Badge>) {
    return this.http.put(`${environment.apiUrl}/${this.url}/${id}`, badge);
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/${this.url}/${id}`);
  }
}
